var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.79 6.9697L8.73 14.0307C8.6 14.1597 8.42 14.2407 8.24 14.2407C8.22 14.2407 8.21 14.2407 8.2 14.2307C8.01 14.2307 7.82 14.1297 7.69 13.9807L4.16 9.7497C3.91 9.4497 3.95 8.9997 4.25 8.7497C4.55 8.4997 5 8.5397 5.25 8.8397L8.28 12.4807L14.79 5.9697C15.07 5.6997 15.519 5.6997 15.79 5.9697C16.07 6.2497 16.07 6.6907 15.79 6.9697ZM10 -0.000297546C4.48 -0.000297546 0 4.4807 0 9.9997C0 15.5197 4.48 19.9997 10 19.9997C15.519 19.9997 20 15.5197 20 9.9997C20 4.4807 15.519 -0.000297546 10 -0.000297546Z",
    fill: "#347F51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.3f06793339512fd8a3cd1976be3f9447.svg";
export { ForwardRef as ReactComponent };